<template>
  <div class="mb-4">
    <b-overlay
      :show="loadingInit"
      rounded
      opacity="0.8"
      spinner-small
      spinner-variant="primary"
      class="d-inline-block w-100"
    >
      <modal-confirm-action
        variant='danger'
        refModal='removeList'
        idModal='removeList'
        :loading='loading'
        :description='descriptionRemove'
        :title='titleRemove'
        @confirmed='deletePromotionalCodes'
      />

      <modal-confirm-action
        variant='danger'
        refModal='removeCoupon'
        idModal='removeCoupon'
        :loading='loading'
        :description='descriptionRemove'
        :title='titleRemove'
        @confirmed='remove'
      />

      <b-modal
        ref='promotion'
        size='lg'
        scrollable hide-footer
        title='Adicionar usuário na lista de Promoções de Renovação'
        header-bg-variant='info'
        header-text-variant='light'
      >
        <div class='modal-list-create-promocode modal-font-family'>
          <div class='mb-3'>
            <label class='label'>
              E-mail
            </label>
            <b-form-input
              v-model='userPromotionalCode.client'
              label='Email do usuário'
              :state='validEmail'
              class='form-coupon'
              placeholder='Digite o email do usuário'>
            </b-form-input>

            <b-form-invalid-feedback :state='validEmail'>
              Este campo precisa ser um e-mail válido
            </b-form-invalid-feedback>
          </div>

          <div class='d-flex'>
            <base-button
              class='mr-1 w-50'
              block
              danger
              @click='closePromotion()'
            >
              Cancelar
            </base-button>

            <b-overlay
              :show="addedUser"
              rounded
              opacity="0.6"
              spinner-small
              spinner-variant="primary"
              class="d-inline-block w-50"
            >
              <base-button
                @click='addUserPromotionalCodes()'
                success
                :disabled='!validEmail'
                block
              >
                <span>Adicionar</span>
              </base-button>
            </b-overlay>
          </div>
        </div>
      </b-modal>

      <b-modal
        ref='renewalPromotions'
        size='lg'
        scrollable
        hide-footer
        title='Cadastrar lista de Promoções de Renovação'
        header-bg-variant='info'
        header-text-variant='light'
      >
        <div class='modal-list-create-promocode modal-font-family'>
          <div class='mb-3'>
            <label class='label'>
              Descrição
            </label>
            <b-form-input
              v-model='v$.promotionalCode.description.$model'
              label='Descrição'
              class='form-coupon'
              placeholder='Digite a descrição'
            >
            </b-form-input>
          </div>

          <div class='mb-3'>
            <label class='label'>Desconto</label>
            <b-form-input
              id='discount'
              class='form-control form-coupon mb-2'
              type='number'
              placeholder='10'
              v-model='v$.promotionalCode.discount.$model'>
            </b-form-input>
          </div>

          <div class='d-flex'>
            <base-button
              class='mr-1 w-50'
              danger
              @click='closeRenewalPromotions()'
            >
              Cancelar
            </base-button>

            <b-overlay
              :show="addedList"
              rounded
              opacity="0.6"
              spinner-small
              spinner-variant="primary"
              class="d-inline-block w-50"
              @hidden="onHidden"
            >
              <base-button
                success
                @click='submitPromotionalCodes()'
                :disabled='v$.$invalid'
                block
              >
                {{ promotionalCode._id ? 'Atualizar' : 'Cadastrar' }}
              </base-button>
            </b-overlay>
          </div>
        </div>
      </b-modal>

      <b-card bg-variant='light' header='Buscar usuário' class='stat-card renewal-search mb-4'>
        <b-input-group>
          <b-form-input
            v-model='pendingQuery'
            placeholder='Buscar por e-mail'
            @keydown.enter='applySearch'
          />
          <b-input-group-append>
            <b-button variant='primary' @click='applySearch'>
              <b-icon icon='search'></b-icon>
              Buscar
            </b-button>
            <b-button variant='outline-secondary' @click='clearSearch'>
              <b-icon icon='x-circle'></b-icon>
              Limpar filtro
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-card>

      <b-card bg-variant='light' header='Lista de desconto de renovação' class='stat-card mb-4'>
        <div class='d-flex align-items-center justify-content-between flex-wrap renewal-header'>
          <p class='renewal-subtitle mb-0'>Regras de desconto aplicadas na renovação e os usuários vinculados a cada uma.</p>
          <b-button variant='primary' class='btn-register' @click='showRenewalPromotions(null, $event)'>
            <b-icon icon='plus'></b-icon>
            Cadastrar regra
          </b-button>
        </div>
      </b-card>

      <div class='stats-grid mb-4'>
        <b-card bg-variant='light' header='Regras ativas' class='stat-card mb-0'>
          <div class='stat-value'>{{ statRegras }}</div>
        </b-card>
        <b-card bg-variant='light' header='Usuários vinculados' class='stat-card mb-0'>
          <div class='stat-value'>{{ statUsuarios }}</div>
        </b-card>
        <b-card bg-variant='light' header='Desconto máximo' class='stat-card mb-0'>
          <div class='stat-value'>{{ statDesconto }}</div>
        </b-card>
        <b-card bg-variant='light' header='Desconto mínimo' class='stat-card mb-0'>
          <div class='stat-value'>{{ statDescontoMin }}</div>
        </b-card>
      </div>

      <b-card no-body class='renewal-list'>
        <b-table
          class='renewal-table mb-0'
          :items='tableItems'
          :fields='tableFields'
          :tbody-tr-class='rowClass'
          borderless
          show-empty
          @row-clicked='onRowClicked'
        >
          <template v-slot:cell(discount)='{ item }'>
            <span class='rule-discount'>{{ item.discount }}%</span>
          </template>

          <template v-slot:cell(usuarios)='{ item }'>
            <b-badge
              pill
              variant='light'
              class='rule-count'
              :class="{ 'rule-count--empty': !item.promoCodeCount }"
            >
              {{ item.promoCodeCount }}
            </b-badge>
          </template>

          <template v-slot:cell(acoes)='{ item }'>
            <div class='d-flex justify-content-end align-items-center' style='gap: 0.5rem'>
              <b-button size='sm' variant='success' @click='showPromotion(item._id, $event)'>
                <b-icon icon='person-plus'></b-icon>
                Adicionar usuário
              </b-button>
              <b-button size='sm' variant='success' @click='showRenewalPromotions(item, $event)'>
                <b-icon icon='pencil'></b-icon>
                Editar
              </b-button>
              <b-button size='sm' variant='danger' @click='showDialogConfurmationsDetelePromotionalCodes(item, $event)'>
                <b-icon icon='trash'></b-icon>
                Excluir
              </b-button>
            </div>
          </template>


          <template v-slot:row-details='{ item }'>
            <div class='rule-detail'>
              <div v-if='!listUsers[item._id]' class='text-center py-2'>
                <b-spinner small variant='primary'></b-spinner>
              </div>

              <template v-else>
                <b-form-input
                  v-if='listUsers[item._id].length'
                  :value='userDrafts[item._id] || ""'
                  size='sm'
                  class='mb-2'
                  placeholder='Buscar usuário na lista'
                  @input='onUserDraft(item._id, $event)'
                />

                <b-list-group v-if='filteredUsers(item).length'>
                  <b-list-group-item
                    class='d-flex justify-content-between align-items-center flex-wrap user-row'
                    v-for='promo in filteredUsers(item)' :key='promo._id'
                  >
                    <span class='user-email'>{{ promo.client }}</span>
                    <div class='d-flex align-items-center user-row-actions'>
                      <b-badge pill variant='light' class='rule-count'>{{ promo.discount }}%</b-badge>
                      <b-button size='sm' variant='danger' @click='showRemoveEmailmodal(promo)'>
                        <b-icon icon='trash'></b-icon>
                        Remover
                      </b-button>
                    </div>
                  </b-list-group-item>
                </b-list-group>

                <b-alert v-else show variant='info' class='text-center mb-0'>
                  Nenhum usuário nesta lista.
                </b-alert>
              </template>
            </div>
          </template>

          <template v-slot:empty>
            <div class='text-center text-muted'>Nenhuma regra encontrada.</div>
          </template>
        </b-table>
      </b-card>

      <template v-slot:overlay>
        <div class="text-center loading">
          <b-spinner style="width: 2.5rem; height: 2.5rem;" variant='primary' label="Large Spinner"></b-spinner>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import useVuelidate from '@vuelidate/core'
import { between } from '@vuelidate/validators'
import { required } from '@/utils/validators'
import DialogConfirmation from '@/components/DialogConfirmation.vue'
import ModalConfirmAction from '@/components/ModalConfirmAction.vue'

export default {
  name: 'CreatePromocode',
  setup() {
    return { v$: useVuelidate() }
  },
  components: {
    DialogConfirmation,
    ModalConfirmAction,
  },
  data() {
    return {
      breadcrumbTabsName: 'Lista de desconto de renovação',
      loading: false,
      descriptionRemove: '',
      titleRemove: '',
      idCouponRemove: null,
      addedUser: false,
      addedList: false,
      deletePromotionalCodesId: null,
      openDialog: false,
      loadingInit: false,
      userPromotionalCode: {
        client: null,
        promotionalCodesId: ''
      },
      errors: {
        client: '',
        description: ''
      },
      pendingQuery: '',
      query: '',
      userDrafts: {},
      listUsers: {},
      expandedId: null,
      tableFields: [
        { key: 'description', label: 'Descrição', tdClass: 'align-middle' },
        { key: 'discount', label: 'Desconto', class: 'text-center align-middle' },
        { key: 'usuarios', label: 'Usuários', class: 'text-center align-middle' },
        { key: 'acoes', label: 'Ações', thClass: 'text-right', tdClass: 'text-right align-middle' }
      ],
    }
  },
  async created() {
    this.loadingInit = true
    //await this.getRenew()
    await this.init()
    this.setBreadcrumbTabsName('Lista de desconto de renovação')
    this.loadingInit = false
  },
  validations() {
    return {
      promotionalCode: {
        description: { required },
        discount: { required, betweenValue: between(1, 100) }
      }
    }
  },
  computed: {
    ...mapGetters('promocodes', {
      promocode: 'promocode',
      promotionalCode: 'promotionalCode',
      renews: 'renews',
      promotionalCodes: 'promotionalCodes',
      promotionalCodesStats: 'promotionalCodesStats'
    }),


    validEmail() {
      const regexIsEmail = /\S+@\S+\.\S+/
      return this.userPromotionalCode.client ? !!(regexIsEmail.test(this.userPromotionalCode.client) && this.userPromotionalCode.client) : null
    },
    max() {
      return !!(Number(this.promocode.discount) < 100 && this.promocode.discount)
    },
    statRegras() {
      return this.promotionalCodesStats.rules
    },
    statUsuarios() {
      return this.promotionalCodesStats.linkedUsers
    },
    statDesconto() {
      return `${this.promotionalCodesStats.maxDiscount}%`
    },
    statDescontoMin() {
      return `${this.promotionalCodesStats.minDiscount}%`
    },
    tableItems() {
      return this.promotionalCodes.map((code) => ({
        ...code,
        _showDetails: code._id === this.expandedId
      }))
    }
  },
  methods: {
    ...mapActions('promocodes', {
      handleCreatePromocode: 'handleCreatePromocode',
      handleCreatePromotionalCodes: 'handleCreatePromotionalCodes',
      removePromocode: 'removePromocode',
      handleClearPromocode: 'handleClearPromocode',
      getRenew: 'getRenew',
      getAllPromotionalCodes: 'getAllPromotionalCodes',
      getPromotionalCodesStats: 'getPromotionalCodesStats',
      getPromotionalCodeUsers: 'getPromotionalCodeUsers',
      setListPromocode: 'setListPromocode',
      resetListPromocode: 'resetListPromocode',
      handleUpdatePromotionalCodes: 'handleUpdatePromotionalCodes',
      handleAddUserPromotionalCodes: 'handleAddUserPromotionalCodes',
      handleGetPromotionalCodes: 'handleGetPromotionalCodes',
      handleDeletePromotionalCodes: 'handleDeletePromotionalCodes'
    }),
    ...mapActions('breadcrumb', {
      setBreadcrumb: 'setBreadcrumb',
    }),
    setBreadcrumbTabsName(breadcrumbTabsName){
      this.breadcrumbTabsName = breadcrumbTabsName;
      const breadcrumb = {
        page: 'Relatórios',
        subPage: {
          name: 'Relatórios',
          active: false
        },
        tabs: [
          {
            name: this.breadcrumbTabsName,
            active: true
          }
        ]
      }
      this.setBreadcrumb(breadcrumb)
    },
    async init() {
      this.loadingInit = true
      this.listUsers = {}
      await Promise.all([this.getAllPromotionalCodes(this.query), this.getPromotionalCodesStats(this.query)])
      if (this.expandedId) {
        await this.loadListUsers(this.expandedId)
      }
      this.loadingInit = false
    },

    async loadListUsers(id) {
      const users = await this.getPromotionalCodeUsers({ id, search: this.query })
      this.$set(this.listUsers, id, users)
    },

    onHidden() {
      this.$refs.button.focus()
    },

    isValid() {
      const regexIsEmail = /\S+@\S+\.\S+/
      const isEmail = regexIsEmail.test(this.promocode.client)

      if (!isEmail) {
        if (this.promocode.client) {
          this.errors.client = 'Este campo precisa ser um email'
        }

        return false
      }
      if (!this.max) {
        return false
      }

      this.errors.client = ''
      return true
    },

    async handleSubmit() {
      const response = await this.handleCreatePromocode()

      let message = ''
      let variant = ''

      if (response.message) {
        message = response.message
        variant = 'success'
        await this.handleClearPromocode()
      }
      if (response.errors) {
        message = response.errors
        variant = 'danger'
      }

      this.$bvToast.toast(message, {
        title: 'Aviso',
        variant: variant,
        toaster: 'b-toaster-top-center',
        autoHideDelay: 5000
      })
      this.loadingInit = true
      await this.getRenew()
      this.loadingInit = false
    },
    showRemoveEmailmodal(coupon){
      this.descriptionRemove = `Tem certeza que deseja excluir o cupom de desconto do e-mail: ${coupon.client} ?`
      this.titleRemove = `Excluir cupom de desconto`
      this.idCouponRemove = coupon._id
      this.$bvModal.show('removeCoupon')
    },

    async remove() {
      try {
        this.loading = true;
        const response = await this.removePromocode(this.idCouponRemove)

        let message = ''
        let variant = ''

        if (response.message) {
          message = response.message
          variant = 'success'
          await this.handleClearPromocode()
        }
        if (response.errors) {
          message = response.errors
          variant = 'danger'
        }

        this.$bvToast.toast(message, {
          title: 'Aviso',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
        this.loadingInit = true
        await this.getRenew()
        await this.init()
        this.loading = false;
        this.loadingInit = false
        this.$bvModal.hide('removeCoupon')
      } catch (e){

      }
    },

    showRenewalPromotions(list, event) {
      event.stopPropagation()
      this.resetListPromocode()
      if (list) {
        this.setListPromocode(list)
        this.handleGetPromotionalCodes(list._id)
      }
      this.$refs['renewalPromotions'].show()
    },

    closeRenewalPromotions() {
      this.$refs['renewalPromotions'].hide()
    },

    showPromotion(promotionalCodesId, event) {
      event.stopPropagation()
      this.userPromotionalCode.client = null
      this.userPromotionalCode.promotionalCodesId = promotionalCodesId
      this.$refs['promotion'].show()
    },

    closePromotion() {
      this.$refs['promotion'].hide()
    },

    async submitPromotionalCodes() {
      try {
        this.addedList = true;
        let response = ''
        if (this.promotionalCode._id) {
          response = await this.handleUpdatePromotionalCodes(this.promotionalCode._id)
        } else {
          response = await this.handleCreatePromotionalCodes()
        }
        let message = ''
        let variant = ''
        if (response.message) {
          message = response.message
          variant = 'success'
          await this.handleClearPromocode()
        }
        if (response.errors) {
          message = response.errors
          variant = 'danger'
        }

        this.$bvToast.toast(message, {
          title: 'Aviso',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
        this.closeRenewalPromotions()
        await this.init()
      } catch (e) {

      } finally {
        this.addedList = false;
      }
    },

    async addUserPromotionalCodes() {
      try {
        this.addedUser = true;
        const response = await this.handleAddUserPromotionalCodes(this.userPromotionalCode)

        let message = ''
        let variant = ''
        if (response.message) {
          message = response.message
          variant = 'success'
          await this.handleClearPromocode()
        }
        if (response.errors) {
          message = response.errors
          variant = 'danger'
        }

        this.$bvToast.toast(message, {
          title: 'Aviso',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
        this.closeRenewalPromotions()
        await this.init()
        this.closePromotion()
        await this.init()
      } catch (e) {

      } finally {
        this.addedUser = false;
      }
    },

    async deletePromotionalCodes() {
      try {
        this.loading = true
        await this.handleDeletePromotionalCodes(this.deletePromotionalCodesId)
        await this.init()
        this.$bvModal.hide('removeList')
        this.loading = false
      } catch (e) {

      }
    },

    showDialogConfurmationsDetelePromotionalCodes(promotionalCodes, event) {
      event.stopPropagation()
      this.deletePromotionalCodesId = promotionalCodes._id
      this.descriptionRemove = `Esta ação vai excluir a lista com os cupons de desconto e os cupons de desconto da lista: ${promotionalCodes.description}. Deseja realmente executar essa ação?`
      this.titleRemove = `Excluir lista de cupons de desconto`
      this.$bvModal.show('removeList')
    },

    async applySearch() {
      this.query = this.pendingQuery
      await this.reloadList()
    },

    async clearSearch() {
      this.query = ''
      this.pendingQuery = ''
      await this.reloadList()
    },

    async reloadList() {
      this.loadingInit = true
      this.expandedId = null
      this.listUsers = {}
      await Promise.all([this.getAllPromotionalCodes(this.query), this.getPromotionalCodesStats(this.query)])
      this.loadingInit = false
    },

    rowClass(item, type) {
      return type === 'row' ? 'rule-row' : ''
    },

    async onRowClicked(item) {
      if (this.expandedId === item._id) {
        this.expandedId = null
        return
      }
      this.expandedId = item._id
      this.$delete(this.listUsers, item._id)
      await this.loadListUsers(item._id)
    },

    onUserDraft(id, value) {
      this.$set(this.userDrafts, id, value)
    },

    filteredUsers(code) {
      const users = this.listUsers[code._id] || []
      const draft = (this.userDrafts[code._id] || '').trim().toLowerCase()
      if (!draft) return users
      return users.filter((promo) => (promo.client || '').toLowerCase().includes(draft))
    }
  }

}
</script>

<style lang='scss' scoped>
.renewal-header {
  gap: 16px;
}

.renewal-subtitle {
  margin: 4px 0 0;
  font-size: 1rem;
  color: #6c757d;
}

.btn-register {
  border-radius: 4px;
  font-weight: bold;
}

.btn-primary,
.btn-primary:focus,
.btn-primary:active,
.btn-primary:not(:disabled):not(.disabled):active {
  background-color: var(--navy-blue);
  border-color: var(--navy-blue);
  box-shadow: none;
}

.btn-primary:hover {
  background-color: #053a72;
  border-color: #053a72;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
}

@media (max-width: 767.98px) {
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.stat-card {
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.stat-card /deep/ .card-header {
  background: var(--navy-blue);
  border-bottom-color: var(--navy-blue);
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #fff;
}

.stat-value {
  font-size: 1.75rem;
  font-weight: 500;
  color: #212529;
  line-height: 1.2;
}

.renewal-table /deep/ thead th {
  border: 0;
  border-bottom: 1px solid #dee2e6;
  padding: 0.5rem 1.25rem;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #6c757d;
}

.renewal-table /deep/ tbody td {
  padding: 0.75rem 1.25rem;
  border: 0;
  vertical-align: middle;
}

.renewal-table /deep/ th:not(:first-child),
.renewal-table /deep/ td:not(:first-child) {
  width: 1%;
  white-space: nowrap;
}

.renewal-table /deep/ tr.rule-row > td {
  background: var(--navy-blue);
  color: #fff;
  border-bottom: 1px solid #fff;
  cursor: pointer;
}

.renewal-table /deep/ tr.rule-row:hover > td {
  background: #053a72;
}

.renewal-table /deep/ tr.b-table-details > td {
  padding: 0;
}

.rule-discount {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.rule-count {
  min-width: 1.75rem;
  padding: 0.35em 0.55em;
  background: #fff;
  color: var(--navy-blue);
  font-size: 0.8rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.rule-count--empty {
  background: rgba(255, 255, 255, 0.85);
  color: #6c86ab;
}

.rule-detail {
  background: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  padding: 1rem 1.25rem 1.25rem;
}

.user-row {
  gap: 0.5rem 1rem;

  .user-email {
    min-width: 0;
    overflow-wrap: anywhere;
  }

  .user-row-actions {
    gap: 0.75rem;
  }
}

.form-coupon {
  height: 48px;
}

.label {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: -6px;
}
</style>
